/**
 * Google AdSense Initialization
 * 
 * Always loads the AdSense script to support Google's approval process.
 * Google needs to see the script and ad units on the site for verification.
 */

// Always load AdSense script (required for Google approval process)
// Google needs to see the script and ad units on the site to verify the implementation
const script = document.createElement('script');
script.async = true;
script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5985195929723169';
script.crossOrigin = 'anonymous';
document.head.appendChild(script);
console.log('✅ Google AdSense script loaded (required for approval)');

